var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TeaserEventsHomeOverview',{attrs:{"id":_vm.anchorName,"all-events-link":_vm.allEventsLink,"headline":_vm.headline,"teasers":_vm.teasers}})
}
var staticRenderFns = []

export { render, staticRenderFns }